import Splide from '@splidejs/splide'
import Alpine from 'alpinejs'

export const initImageSlider = () => {
    Alpine.data('initImageSlider', () => ({
        init() {
            const splide = new Splide(this.$el, {
                arrows: true,
                pagination: false,
                updateOnMove: true,
                focus: 0,
                omitEnd: true,
                mediaQuery: 'min',
                lazyLoad: 'sequential',
                autoWidth: false,
                breakpoints: {
                    0: {
                        gap: 15,
                    },
                    1024: {
                        autoWidth: true,
                        gap: 30,
                        fixedHeight: '480px',
                    },
                    1200: {
                        fixedHeight: '540px',
                    },
                },
            })

            // event on overflowing content to enable / disable interactions
            splide.on('overflow', function (isOverflow) {
                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                }
            })

            splide.mount()
        },
    }))
}
